import { EyeOutlined, FileImageOutlined, FileTextFilled, UserOutlined } from '@ant-design/icons'
import { Avatar, Image } from 'antd'
import * as PropTypes from 'prop-types'
import React, { useState } from 'react'

import { ImagePreviewContainer } from './CommonStyles'

const ImagePreview = ({ multiple, src, withMargin, visibleImage, icon, size = 40 }) => {
  const [visible, setVisible] = useState(false)

  const type = src ? src.split('.')[src.split('.').length - 1] : null

  const handlePreview = () => {
    if (src) {
      if (src.startsWith('https://drive.google.com/thumbnail')) {
        const id = src.split('id=')[1]
        window.open(`https://drive.google.com/file/d/${id}/view`, '_blank').focus()
      } else {
        if (!src.startsWith('https://drive.google.com') && ['jpg', 'jpeg', 'png', 'svg', 'webp'].includes(type?.toLowerCase())) {
          setVisible(true)
        } else {
          window.open(src, '_blank').focus()
        }
      }
    }
  }

  return (
    <ImagePreviewContainer
      className={`hide-on-print ${withMargin ? 'with-margin' : ''} ${src ? 'pointer' : ''} ${multiple ? 'multiple' : ''}`}
      size={size}
      onClick={e => (src ? e.stopPropagation() : null)}
    >
      <Avatar
        shape={multiple ? 'circle' : 'square'}
        src={visibleImage || !multiple ? src : null}
        type="primary"
        onClick={handlePreview}
        icon={icon ? <FileImageOutlined /> : multiple ? <FileTextFilled /> : <UserOutlined />}
        size={size}
      />
      {src && (
        <div className="overlay-img">
          <EyeOutlined />
        </div>
      )}
      <Image
        style={{ display: 'none' }}
        src={visible ? src : null}
        preview={{
          visible,
          src,
          onVisibleChange: setVisible
        }}
      />
    </ImagePreviewContainer>
  )
}

ImagePreview.propTypes = {
  src: PropTypes.string,
  size: PropTypes.number,
  withMargin: PropTypes.bool,
  visibleImage: PropTypes.bool,
  multiple: PropTypes.bool,
  icon: PropTypes.bool
}

export default ImagePreview
